import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { TIME_PICKER_LAYOUTS } from "./constants";

export const timePickerDataSchema = z.object({
  value: z.string().optional(),
  range: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  start: z.string().optional(),
  end: z.string().optional(),
  minuteStep: z.coerce.number().optional(),
  placeholder: z.string().optional(),
  size: z.enum(SIZES).optional(),
  layout: z.enum(TIME_PICKER_LAYOUTS).optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  arrow: z
    .string()
    .optional()
    .transform((value) =>
      value === undefined ? undefined : value !== "false",
    ),
});

export type TimePickerDataProps = z.infer<typeof timePickerDataSchema>;
